/* eslint-disable global-require */
import config from './config';
import system from './system';
import utils from './utils';
import browserWindow from './browserWindow';
import dialog from './dialog';

// TODO: common dataModel 引入顺序不可更改，因其中有依赖关系，后续剥离此依赖关系
import common from './common';
import dataModel from './model';
import voipInviteMember from './modules/voip/voip-invitemember';
import rceCall from './modules/voip/rce-call';
import initIM from './im';

const RongIM = {
    config,
    dialog,
    system,
    utils,
};
// 后续需移除对 RongIM 的二次赋值
common(RongIM);
dataModel(RongIM);
voipInviteMember(RongIM);
rceCall(RongIM);
initIM(RongIM);

if (IS_DESKTOP) {
    RongDesktop.window.on('maximize', () => {
        if (RongIM.instance) {
            RongIM.instance.isMaxWindow = true;
        }
    });
    RongDesktop.window.on('unmaximize', () => {
        if (RongIM.instance) {
            RongIM.instance.isMaxWindow = false;
        }
    });
    // 测试 onDockClick
    RongDesktop.ipcRenderer.on('hide', () => {
        if (browserWindow.onHide) {
            browserWindow.onHide();
        }
    });
    RongDesktop.system.onResume = function onResume() {
        if (RongIM.system.onResume) {
            RongIM.system.onResume();
        }
    };
    RongDesktop.system.onSuspend = function onSuspend() {
        if (RongIM.system.onSuspend) {
            RongIM.system.onSuspend();
        }
    };
}

// TODO: 组件挂载 RongIM 引用，以迁移 components 内容时新迁移组件方便拿取 RongIM
Vue.prototype.RongIM = RongIM;
Vue.prototype.$im = () => RongIM.instance;
// TODO: 为兼容原组件声明方式及业务，全局挂载 RongIM
window.RongIM = RongIM;

// 图片查看器，只有在 web 版才需引用
if (!IS_DESKTOP) {
    require('../pages/image-viewer/index.js');
}

(() => {
    if (typeof String.prototype.startsWith !== 'function') {
        // eslint-disable-next-line no-extend-native
        String.prototype.startsWith = function startsWith(prefix) {
            return this.slice(0, prefix.length) === prefix;
        };
    }
    function initError(message) {
        // eslint-disable-next-line no-alert
        const bool = window.confirm(`${message}\n| - 点击 "OK" 以重新发送请求！\n| - 点击 "Cancel" 退出应用！`);
        if (bool) {
            window.location.reload();
        } else {
            RongIM.system.exit();
        }
    }
    function loadComplete() {
        const voice = RongIM.config.voice || {};
        RongIMLib.RongIMVoice.init(voice);
        const emoji = RongIM.config.emoji || {};
        RongIMLib.RongIMEmoji.setConfig(emoji);
        setTimeout(() => {
            RongIM.init('#im', (error) => {
                if (error) {
                    initError('服务器配置获取失败 ...!');
                    return;
                }
                $('#preload-message').remove();
            });
        }, 1000);
    }
    $(document).ready(loadComplete);
})();
